<!-- <mat-toolbar color="primary">
    <button [fxShow.lt-md]="true" [fxShow]="false"  mat-icon-button (click)="openSidenav()">
        <mat-icon>menu</mat-icon>
    </button>
    <span>My Account</span>
</mat-toolbar> -->
<div class="content" fxLayout="column" fxLayoutGap="16px"
    [@routeAnimation]="true">
    <mat-tab-group #tabGroup mat-stretch-tabs>

        <mat-tab label="My Profile">
            <mat-card *ngIf="tabGroup.selectedIndex === 0" class="p-3 sm:p-6
                flex flex-col">
                <mat-accordion>
                    <mat-expansion-panel hideToggle>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <b>User Information</b>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <form [formGroup]="extUserFormGroup" class="content"
                            fxLayout="column" fxLayoutGap="16px">
                            <mat-form-field>
                                <input type="text" matInput placeholder="First
                                    Name" maxlength="150"
                                    formControlName="firstName">
                            </mat-form-field>
                            <mat-form-field>
                                <input type="text" matInput placeholder="Last
                                    Name" maxlength="150"
                                    formControlName="lastName">
                            </mat-form-field>
                            <mat-form-field>
                                <input type="email" matInput placeholder="Email
                                    Address" maxlength="254"
                                    formControlName="email" readonly>
                            </mat-form-field>
                        </form>
                    </mat-expansion-panel>
                </mat-accordion>
                <!--OrgInfo-->
                <mat-accordion>
                    <mat-expansion-panel hideToggle>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <b>Organization Information </b>
                                <mat-icon
                                    *ngIf="extUserFormGroup.value.isVerified !==
                                    1" color="warn" align="end">error
                                </mat-icon>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <form [formGroup]="extOrgInfoFormGroup" class="content"
                            fxLayout="column" fxLayoutGap="16px">
                            <mat-error *ngIf="extUserFormGroup.value.isVerified
                                !== 1">Your organization information and
                                tax-exempt status cannot be verified. Please
                                contact contributions@lge-ku.com with questions.
                            </mat-error>
                            <mat-form-field>
                                <input type="text" matInput
                                    placeholder="Organization Name"
                                    maxlength="50" formControlName="name"
                                    readonly>
                            </mat-form-field>
                            <mat-form-field>
                                <input type="text" matInput placeholder="EIN"
                                    maxlength="10" formControlName="EIN"
                                    readonly>
                            </mat-form-field>
                            <mat-form-field>
                                <input type="text" matInput placeholder="Web
                                    Address" maxlength="250"
                                    formControlName="webAddress">
                            </mat-form-field>
                            <mat-form-field>
                                <input type="text" matInput
                                    placeholder="Address1" maxlength="35"
                                    formControlName="address1">
                            </mat-form-field>
                            <mat-form-field>
                                <input type="text" matInput
                                    placeholder="Address2" maxlength="35"
                                    formControlName="address2">
                            </mat-form-field>
                            <mat-form-field>
                                <input type="text" matInput placeholder="City"
                                    maxlength="50" formControlName="city">
                            </mat-form-field>
                            <mat-form-field>
                                <input type="text" matInput placeholder="State"
                                    maxlength="50" formControlName="state">
                            </mat-form-field>
                            <mat-form-field>
                                <input type="text" zipCode matInput
                                    placeholder="Zip Code" maxlength="9"
                                    formControlName="zipCode">
                            </mat-form-field>
                            <mat-form-field>
                                <input type="text" matInput
                                    placeholder="Tax-Exempt Status"
                                    maxlength="15"
                                    [value]="getTaxExemptStatus(extOrgInfoFormGroup.value.subsection_501)"
                                    readonly>
                            </mat-form-field>
                        </form>
                    </mat-expansion-panel>
                </mat-accordion>
                <!--OrgContactInfo-->
                <mat-accordion>
                    <mat-expansion-panel hideToggle>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <b>Contact Information</b>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <form [formGroup]="extOrgContactInfoFormGroup"
                            class="content" fxLayout="column"
                            fxLayoutGap="16px">
                            <mat-card-subtitle>
                                <b>Primary Contact</b>
                            </mat-card-subtitle>
                            <mat-form-field>
                                <input type="text" matInput placeholder="First
                                    Name" maxlength="150"
                                    formControlName="firstName">
                            </mat-form-field>
                            <mat-form-field>
                                <input type="text" matInput placeholder="Last
                                    Name" maxlength="150"
                                    formControlName="lastName">
                            </mat-form-field>
                            <mat-form-field>
                                <input type="text" phone matInput
                                    placeholder="Phone Number" maxlength="12"
                                    formControlName="phone">
                            </mat-form-field>
                            <mat-form-field>
                                <input type="email" matInput placeholder="Email
                                    Address" maxlength="254"
                                    formControlName="email">
                            </mat-form-field>
                            <mat-card-subtitle>
                                <b>Secondary Contact</b>
                            </mat-card-subtitle>
                            <mat-form-field>
                                <input type="text" matInput placeholder="First
                                    Name" maxlength="150"
                                    formControlName="secondaryFirstName">
                            </mat-form-field>
                            <mat-form-field>
                                <input type="text" matInput placeholder="Last
                                    Name" maxlength="150"
                                    formControlName="secondaryLastName">
                            </mat-form-field>
                            <mat-form-field>
                                <input type="text" phone matInput
                                    placeholder="Phone Number" maxlength="12"
                                    formControlName="secondaryPhone">
                            </mat-form-field>
                            <mat-form-field>
                                <input type="email" matInput placeholder="Email
                                    Address" maxlength="254"
                                    formControlName="secondaryEmail">
                            </mat-form-field>
                        </form>
                    </mat-expansion-panel>
                </mat-accordion>
                <div class="
                    flex
                    flex-row w-full
                    justify-center
                    items-center
                    content-center">
                    <button mat-raised-button color="primary"
                        class="!rounded-xl"
                        [disabled]="(extUserFormGroup.invalid ||
                        extOrgInfoFormGroup.invalid ||
                        extOrgContactInfoFormGroup.invalid) ||
                        (extUserFormGroup.pristine &&
                        extOrgInfoFormGroup.pristine &&
                        extOrgContactInfoFormGroup.pristine)"
                        (click)="submitUpdates()">
                        Save Profile Changes
                    </button>
                </div>
            </mat-card>
        </mat-tab>

        <mat-tab label="Change/Update Password">
            <mat-card fxLayout="column">
                <form [formGroup]="setPasswordFormGroup" class="content"
                    fxLayout="column" fxLayout.sm="column" fxLayout.xs="column"
                    fxLayoutGap="16px">
                    <mat-card-subtitle>
                        <b>Change Password</b>
                    </mat-card-subtitle>
                    <mat-form-field>
                        <input type="password" appearance="outline" matInput
                            placeholder="Current
                            Password" formControlName="oldPassword">
                    </mat-form-field>
                    <mat-form-field>
                        <input type="password" appearance="outline" matInput
                            placeholder="New
                            Password" formControlName="password">
                        <mat-hint align="end">Password must contain at least 8
                            characters.</mat-hint>
                    </mat-form-field>
                    <mat-form-field>
                        <input type="password" appearance="outline" matInput
                            placeholder="Confirm New
                            Password" formControlName="confirmPassword">
                    </mat-form-field>
                    <div fxLayout="column" fxLayoutAlign="center center">
                        <button mat-raised-button (click)="setPassword()"
                            [disabled]="setPasswordFormGroup.invalid"
                            class="login-button" color="primary">Save New
                            Password</button>
                    </div>
                </form>
            </mat-card>
        </mat-tab>

    </mat-tab-group>
</div>